import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { css } from "styled-components";

actionStyles.addTagsButton = {
    css: css`
        padding: 0 10px;
        margin-right: 10px;
        white-space: nowrap;
        border-radius: 24px;
        padding: 0px 15px;
        min-height: 32px;
        height: 32px;
    `,
    variant: "secondary",
};

actionStyles.iconContainer = {
    css: css`
    width: 15px;
    margin-top: 12px;
    align-self: center;
`,
};

